// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-container .del-btn[data-v-ef9eb6f2],\n.btn-container .add-btn[data-v-ef9eb6f2] {\n  height: 32px !important;\n}", ""]);
// Exports
module.exports = exports;
